const DISMISS_KEY = "ai-support-monitor.about.dismissed";
const SEEN_KEY = "ai-support-monitor.about.seenCount";
const MAX_AUTO_SHOWS = 2;

export function isAboutDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISS_KEY) === "1";
  } catch {
    return false;
  }
}

export function getAboutSeenCount(): number {
  try {
    const raw = Number(localStorage.getItem(SEEN_KEY) ?? "0");
    return Number.isFinite(raw) && raw > 0 ? Math.floor(raw) : 0;
  } catch {
    return 0;
  }
}

export function shouldAutoShowAbout(): boolean {
  return !isAboutDismissed() && getAboutSeenCount() < MAX_AUTO_SHOWS;
}

export function markAboutShown(): void {
  try {
    localStorage.setItem(SEEN_KEY, String(getAboutSeenCount() + 1));
  } catch {
    // ignore quota / private mode
  }
}

export function dismissAboutPermanently(): void {
  try {
    localStorage.setItem(DISMISS_KEY, "1");
  } catch {
    // ignore
  }
}

/** UI에 고정 표기하는 배점·등급(config/scoring.yml과 동기 유지). */
export const ABOUT_SCORE_ROWS = [
  { label: "신청자격 일치", points: 30 },
  { label: "기술 연관성", points: 25 },
  { label: "3개월 제안 가능성", points: 15 },
  { label: "지원 조건·규모", points: 10 },
  { label: "사업화·시장", points: 10 },
  { label: "협력·컨소시엄 준비", points: 5 },
  { label: "후속 연계", points: 5 },
] as const;

export const ABOUT_GRADE_ROWS = [
  { label: "매우 적합", range: "80~100" },
  { label: "적합", range: "60~79" },
  { label: "조건부 적합", range: "40~59" },
  { label: "부적합 가능성 높음", range: "20~39" },
  { label: "사실상 부적합", range: "0~19" },
] as const;
